import { useReducer, useCallback } from 'react'
import { arrayDifference } from 'utils/helpers'
import { axiosApi } from 'services/api'
import selectableSlice, { initialState } from 'features/patient-details/selectableSlice'

export const useSelectable = (files, filter) => {
    const { reducer, actions } = selectableSlice
    const { selectAll, unSelectAll, unSelectAllFiltered, unSelectFile } = actions
    const [selectable, dispatch] = useReducer(reducer, initialState)

    const getFilteredFileIds = useCallback(() => {
        let fileIds = []
        if (filter !== 'all') {
            fileIds = files?.filter(f => f.fileType === filter).map(f => f.fileId) || []
        } else {
            fileIds = files?.map(f => f.fileId) || []
        }
        return fileIds
    }, [filter, files])

    const handleSelectFile = useCallback(
        (isChecked, ids) => {
            const fileIds = typeof ids === 'string' ? [ids] : ids
            if (isChecked) {
                dispatch(selectAll({ fileIds }))
            } else {
                dispatch(unSelectFile({ fileIds }))
            }
        },
        [filter, files]
    )

    const handleSelectAll = useCallback(
        isChecked => {
            if (isChecked) {
                dispatch(selectAll({ fileIds: getFilteredFileIds() }))
            } else {
                if (filter !== 'all') {
                    dispatch(unSelectAllFiltered({ fileIds: getFilteredFileIds() }))
                } else {
                    dispatch(unSelectAll())
                }
            }
        },
        [filter, files]
    )

    const isSelectedAll =
        !Boolean(arrayDifference(getFilteredFileIds(), selectable.selectedFiles).length) &&
        getFilteredFileIds().length > 0

    return {
        actions,
        selectable,
        selectedFiles: selectable.selectedFiles,
        dispatch,
        handleSelectFile,
        handleSelectAll,
        isSelectedAll,
    }
}
